import { render, staticRenderFns } from "./InventoryTitleCapture.vue?vue&type=template&id=b13a0732&scoped=true"
import script from "./InventoryTitleCapture.vue?vue&type=script&lang=js"
export * from "./InventoryTitleCapture.vue?vue&type=script&lang=js"
import "./InventoryTitleCapture.vue?vue&type=style&index=0&id=b13a0732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13a0732",
  null
  
)

export default component.exports